__turbopack_context__.v({
  "container": "EsoOBG_container",
  "rotate": "EsoOBG_rotate",
  "spinningSegment": "EsoOBG_spinningSegment",
  "track": "EsoOBG_track",
});
